module.exports = "<div class=\"footer\">\r\n    <div class=\"pull-right\">\r\n        <strong>Copyright</strong> TecniSeguros &copy; {{fecha}}\r\n    </div>\r\n    <div>\r\n\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/components/common/footer/footer.template.html
// module id = ../../../../../src/app/components/common/footer/footer.template.html
// module chunks = 0